import React from 'react'

import { Primary } from 'home/features/primary'
import { Secondary } from 'home/features/secondary'

export const Features = () => <>
  <Primary />
  <Secondary />
</>
